/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const OtpR = t.interface({});

// optional attributes
const OtpO = t.partial({
  value: t.string
});

export const Otp = t.intersection([OtpR, OtpO], "Otp");

export type Otp = t.TypeOf<typeof Otp>;
